import axios from "axios";
const API_URL_COURSE = "/api/courses/";
const API_URL__GET_LESSONS = "/api/getChallenges/";
const API_URL_LESSON = "/api/lesson/";

const getCourses = async (courseType) => {
  //   const config = {
  //     headers: {
  //       Authorization: `Bearer ${token}`,
  //     },
  //   };

  //const response = await axios.get(API_URL, config);

  let response;
  try {
    response = await axios.get(API_URL_COURSE + courseType);
  } catch (err) {
    console.log(err);
  }
  return response.data;
};

const getLessonsForCourse = async (slug) => {
  const response = await axios.get(API_URL__GET_LESSONS + slug);
  return response.data;
};

const getLesson = async (challengeIdOrSlug) => {
  let response;
  try {
    response = await axios.get(API_URL_LESSON + challengeIdOrSlug);
  } catch (e) {
    console.log(e);
  }

  return response.data;
};

const getInstallData = async (dataKey) => {
  let response;
  try {
    response = await axios.get("/api/installData/" + dataKey);
  } catch (e) {
    console.log(e);
  }

  return response.data;
};

const getPackageStatus = async (packageId) => {
  let response;
  try {
    response = await axios.get("/api/packageStatus/" + packageId);
  } catch (e) {
    console.log(e);
  }

  return response.data;
};

const executeLesson = async (payload) => {
  const options = {
    method: "POST",
    data: payload,
    url: "/api/submit/",
  };

  let response;
  try {
    response = await axios(options);
  } catch (e) {
    console.log(e);
  }

  return response.data;
};

const executeReadingCompleted = async (payload) => {
  const options = {
    method: "POST",
    data: payload,
    url: "/api/submitReading/",
  };

  let response = await axios(options);

  return response.data;
};

const executeCodeReset = async (payload) => {
  const options = {
    method: "POST",
    data: payload,
    url: "/api/reset/",
  };

  let response = await axios(options);

  return response.data;
};

const getAuthor = async (authorId) => {
  let response;
  try {
    response = await axios.get("/api/getAuthor/" + authorId);
  } catch (e) {
    console.log(e);
  }

  return response.data;
};

const getEvents = async () => {
  const options = {
    method: "GET",
    url: "/api/getEvents/",
  };

  let response = await axios(options);

  return response.data;
};

const fetchPracticeData = async () => {
  const options = {
    method: "GET",
    url: "/api/getPracticeData/",
  };

  let response = await axios(options);
  return response.data;
};

const fetchPracticeDataByRole = async (role) => {
  let response = await axios({
    method: "GET",
    url: `/api/getPracticeDataByRole/${role}`,
  });
  return response.data;
};

const deployMetadata = async (metadataType) => {
  const options = {
    method: "POST",
    url: "/api/metadata/deploy",
    data: { metadataType },
  };

  let response = await axios(options);
  return response.data;
};

const deployAdvent = async (metadataType) => {
  const options = {
    method: "POST",
    url: "/api/metadata/deployAdvent",
    data: { metadataType },
  };

  let response = await axios(options);
  return response.data;
};

// Task-related API functions
const getTaskBySlug = async (slug) => {
  let response;
  try {
    response = await axios.get(`/api/tasks/${slug}`);
  } catch (e) {
    console.log(e);
  }
  return response.data;
};

const submitTask = async (payload) => {
  const options = {
    method: "POST",
    data: payload,
    url: `/api/tasks/${payload.taskId}/submit`,
  };

  let response;
  try {
    response = await axios(options);
    return response.data;
  } catch (e) {
    console.log(e);
    throw e;
  }
};

const markChallengeComplete = async (challengeId) => {
  const options = {
    method: "POST",
    url: `/api/challenges/${challengeId}/complete`,
  };

  let response;
  try {
    response = await axios(options);
  } catch (e) {
    console.log(e);
  }
  return response.data;
};

const getTaskProgress = async (challengeId) => {
  let response;
  try {
    response = await axios.get(`/api/challenges/${challengeId}/task-progress`);
  } catch (e) {
    console.log(e);
  }
  return response.data;
};

// Quiz-related API functions
const getQuizBySlug = async (slug) => {
  let response;
  try {
    response = await axios.get(`/api/quizzes/${slug}`);
  } catch (e) {
    console.log(e);
  }
  return response.data;
};

const submitQuiz = async (payload) => {
  const options = {
    method: "POST",
    data: { answers: payload.answers },
    url: `/api/quizzes/${payload.quizId}/submit`,
  };

  let response;
  try {
    response = await axios(options);
    return response.data;
  } catch (e) {
    console.log(e);
    throw e;
  }
};

// Integration credentials (client_id / client_secret) API functions
const generateIntegrationCredentials = async () => {
  const response = await axios.post("/api/integration-credentials/credentials");
  return response.data;
};

const getIntegrationCredentials = async () => {
  const response = await axios.get("/api/integration-credentials/credentials");
  return response.data;
};

const courseService = {
  getLessonsForCourse,
  getCourses,
  getLesson,
  executeLesson,
  executeReadingCompleted,
  executeCodeReset,
  getPackageStatus,
  getInstallData,
  getEvents,
  getAuthor,
  fetchPracticeData,
  fetchPracticeDataByRole,
  deployMetadata,
  deployAdvent,
  getTaskBySlug,
  submitTask,
  markChallengeComplete,
  getTaskProgress,
  getQuizBySlug,
  submitQuiz,
  generateIntegrationCredentials,
  getIntegrationCredentials,
};

export default courseService;
